import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 9C5 8.44772 5.44772 8 6 8H14C14.5523 8 15 8.44772 15 9V12C15 12.5523 14.5523 13 14 13H6C5.44772 13 5 12.5523 5 12V9Z"
      fill="url(#paint0_linear_2075_8194)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4472 3.34166C10.1657 3.20089 9.83431 3.20089 9.55279 3.34166L3.55279 6.34166C3.214 6.51105 3 6.85731 3 7.23608V15C3 16.1046 3.89543 17 5 17H6.57143C7.12371 17 7.57143 17.4477 7.57143 18C7.57143 18.5523 7.12371 19 6.57143 19H5C2.79086 19 1 17.2092 1 15V7.23608C1 6.09977 1.64201 5.06098 2.65836 4.5528L8.65836 1.5528C9.50294 1.13051 10.4971 1.13051 11.3416 1.5528L17.3416 4.5528C18.358 5.06098 19 6.09977 19 7.23608V10.5C19 11.0523 18.5523 11.5 18 11.5C17.4477 11.5 17 11.0523 17 10.5V7.23608C17 6.85731 16.786 6.51105 16.4472 6.34166L10.4472 3.34166ZM16.31 15.8957C16.7471 15.202 17 14.3805 17 13.5C17 11.0147 14.9853 9 12.5 9C10.0147 9 8 11.0147 8 13.5C8 15.9853 10.0147 18 12.5 18C13.3806 18 14.2021 17.7471 14.8958 17.3099L16.5829 18.9971C16.9735 19.3876 17.6066 19.3876 17.9972 18.9971C18.3877 18.6065 18.3877 17.9734 17.9972 17.5829L16.31 15.8957ZM15 13.5C15 14.8807 13.8807 16 12.5 16C11.1193 16 10 14.8807 10 13.5C10 12.1193 11.1193 11 12.5 11C13.8807 11 15 12.1193 15 13.5Z"
      fill="#595959"
    />
    <defs>
      <linearGradient id="paint0_linear_2075_8194" x1="5" y1="8" x2="5" y2="13" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#7B7B7B" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

const activedIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 9C5 8.44772 5.44772 8 6 8H14C14.5523 8 15 8.44772 15 9V12C15 12.5523 14.5523 13 14 13H6C5.44772 13 5 12.5523 5 12V9Z"
      fill="url(#paint0_linear_2075_8186)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4472 3.34166C10.1657 3.20089 9.83431 3.20089 9.55279 3.34166L3.55279 6.34166C3.214 6.51105 3 6.85731 3 7.23608V15C3 16.1046 3.89543 17 5 17H6.57143C7.12371 17 7.57143 17.4477 7.57143 18C7.57143 18.5523 7.12371 19 6.57143 19H5C2.79086 19 1 17.2092 1 15V7.23608C1 6.09977 1.64201 5.06098 2.65836 4.5528L8.65836 1.5528C9.50294 1.13051 10.4971 1.13051 11.3416 1.5528L17.3416 4.5528C18.358 5.06098 19 6.09977 19 7.23608V10.5C19 11.0523 18.5523 11.5 18 11.5C17.4477 11.5 17 11.0523 17 10.5V7.23608C17 6.85731 16.786 6.51105 16.4472 6.34166L10.4472 3.34166Z"
      fill="#2D64FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 13.5C15 14.8807 13.8807 16 12.5 16C11.1193 16 10 14.8807 10 13.5C10 12.1193 11.1193 11 12.5 11C13.8807 11 15 12.1193 15 13.5ZM14.8958 17.3099C14.2021 17.7471 13.3806 18 12.5 18C10.0147 18 8 15.9853 8 13.5C8 11.0147 10.0147 9 12.5 9C14.9853 9 17 11.0147 17 13.5C17 14.3805 16.7471 15.202 16.31 15.8957L17.9972 17.5829C18.3877 17.9734 18.3877 18.6065 17.9972 18.9971C17.6066 19.3876 16.9735 19.3876 16.5829 18.9971L14.8958 17.3099Z"
      fill="#2D64FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2075_8186"
        x1="3.83266"
        y1="7.60365"
        x2="3.43142"
        y2="13.8471"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B3EE" />
        <stop offset="1" stopColor="#2BCAFF" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconPh() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
